import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormParam } from '../models/form/form-param.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmFormParamService extends RequestService<FormParam> {
  static PATH = '/om/form/param';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmFormParamService.PATH, globalService.debugUrl);
  }
}
